<template>
    <div class="team-title">
        <div class="arraat">
            <div v-for="(item, index) in list" :key="index" class="team-list">
                <div :style="{ background: item.backcolor, color: item.color }">
                    {{ index + 1 }}
                </div>
                <div style="color: #dadcde">{{ item.activityName }}</div>
                <div :style="{ color: item.backcolor }">{{ item.count }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    components: {},
    data() {
        return {
            list: [],
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            request({
                url: "/sqyl/admin/activityRecruitment/info/findByActivityName",
                method: "POST",
                data: {},
            }).then((res) => {
                if (res.code == 200) {
                    res.content.forEach((item, index) => {
                        if (index == 0) {
                            item.backcolor = "#fffa61"
                            item.color = "#333333"
                        } else if (index == 1) {
                            item.backcolor = "#eeeeee"
                            item.color = "#333333"
                        } else if (index == 2) {
                            item.backcolor = "#e9c569"
                            item.color = "#333333"
                        } else {
                            item.backcolor = "#1999f7"
                            item.backcolor = "#ffffff"
                        }
                    })
                    this.list = res.content
                } else if (res.code == "10004") {
                    this.$message.error(res.message)
                    this.$router.push("/login")
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
.team-title {
    width: 400px;
    height: 23vh;
    overflow: hidden;
}
.arraat {
    height: 90%;
    overflow-y: auto;
}
.team-list {
    width: 96%;
    display: flex;
    margin: 15px auto;
    font-size: 14px;
}

.team-list > div:first-child {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    line-height: 20px;
    text-align: center;
    margin-right: 10px;
}

.team-list > div:nth-child(2) {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
